import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import AOS from 'aos';
import 'aos/dist/aos.css';
import App from './App.vue';
import router from './router';
import './style.css';
import './styles/layout.css';
import './styles/newhome/tokens.css';
import './styles/newhome/base.css';
import './styles/newhome/typography.css';
import './styles/newhome/reveal.css';
import './styles/newhome/nav.css';
import './styles/newhome/footer.css';
import './styles/portal-v2.css';

const app = createApp(App);
const pinia = createPinia();
const head = createHead();

app.use(pinia);
app.use(router);
app.use(head);

router.isReady().then(() => {
  app.mount('#app');
  AOS.init({
    duration: 900,
    once: true,
    offset: 80
  });
});
